<script >
import TweenMax from "@/assets/js/TweenMax.js"
import { ref, watch, watchEffect, onMounted } from 'vue';

export default {
    props: {
        temp: {
            type: Number,
            default: 0
        }
    },

    setup(props) {
        let counter = ref(0);
        let start = ref(0);
        let end = ref(props.temp);
        const duration = 3;
        onMounted(() => {
            click();
        })
        watch(() => props.temp, (newValue, oldValue) => {
            start.value = oldValue;
            end.value = newValue;
            click();
        })
        const click = () => {
            TweenMax.to(counter, duration, {
                ease: Power2.easeInOut,
                value: end.value,
                onUpdate: () => {
                    const log = counter.value.toFixed(1)
                    counter.value = Number(log);
                }
            });

            TweenMax.set(counter, {
                value: start.value
            });

        }
        return {
            counter
        }
    },
}
</script>
<template>
    <span>{{ counter }}</span>
</template>
<style lang="scss" scoped></style>